/* One matching item per action. Never repeat an unconfirmed cart mutation. */
(() => {
  if (customElements.get('cp-cart-match')) return;
  let operation = false;
  let cartUncertain = false;
  const noticeKey = 'cp-match-notice-v19';
  const route = suffix => (window.Shopify?.routes?.root || '/') + suffix;
  const request = async (url, body) => {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const json = await response.json();
    if (!response.ok) throw new Error(typeof json.description === 'string' ? json.description : 'The bag could not be updated.');
    return json;
  };
  function saveNotice(message) {
    try { if (message) sessionStorage.setItem(noticeKey, JSON.stringify({ message, time: Date.now() })); else sessionStorage.removeItem(noticeKey); } catch (_) {}
    document.querySelectorAll('[data-match-notice]').forEach(el => {el.textContent = message; el.hidden = !message;});
  }
  function updateCount(cart) {
    document.querySelectorAll('cart-icon').forEach(icon => {
      if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count, false, true);
      else customElements.whenDefined('cart-icon').then(() => icon.renderCartBubble?.(cart.item_count, false, true));
    });
  }
  async function refreshBag(cart, cartUrl) {
    updateCount(cart);
    const isCartPage = location.pathname.replace(/\/$/, '') === new URL(cartUrl, location.origin).pathname.replace(/\/$/, '');
    if (isCartPage) { location.reload(); return; }
    const current = document.querySelector('.cart-drawer__inner');
    if (!current) {location.assign(cartUrl); return;}
    const url = new URL(location.href);
    url.searchParams.set('_cp_cart_refresh', String(Date.now()));
    const response = await fetch(url.href, {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error('The bag could not refresh.');
    const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.cart-drawer__inner');
    if (!fresh) throw new Error('The bag could not refresh.');
    const previousScroll = current.querySelector('.cart-drawer__items')?.scrollTop || 0;
    current.innerHTML = fresh.innerHTML;
    requestAnimationFrame(() => {
      const content = current.querySelector('.cart-drawer__items');
      if (content) content.scrollTop = previousScroll;
    });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
  }
  function discountCodes(cart) {
    const codes = (cart.discount_codes || []).map(item => item.code);
    const applications = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    applications.forEach(item => {if (item?.type === 'discount_code') codes.push(item.title);});
    return [...new Set(codes.filter(Boolean))];
  }
  class CartMatches extends HTMLElement {
    connectedCallback() {
      try {
        const notice = JSON.parse(sessionStorage.getItem(noticeKey) || 'null');
        const element = this.querySelector('[data-match-notice]');
        if (element && notice && Date.now() - notice.time < 300000) {element.textContent = notice.message; element.hidden = false;}
      } catch (_) {}
    }
  }
  class CartMatch extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.form = this.querySelector('[data-match-form]');
      this.size = this.querySelector('[data-match-size]');
      this.button = this.querySelector('[data-match-add]');
      this.error = this.querySelector('[data-match-error]');
      this.status = this.querySelector('[data-match-status]');
      if (!this.form || !this.size || !this.button || !this.error) return;
      const options = {signal:this.events.signal};
      this.form.addEventListener('submit', event => {event.preventDefault();event.stopPropagation();this.add();}, options);
      this.size.addEventListener('change', () => {
        this.size.removeAttribute('aria-invalid');this.error.hidden = true;
        const option = this.size.selectedOptions[0];
        if (option?.dataset.price) this.querySelector('[data-match-price]').textContent = option.dataset.price;
        const regularPrice = this.querySelector('[data-match-regular-price]');
        if (regularPrice && option?.dataset.regularPrice) regularPrice.textContent = option.dataset.regularPrice;
        const offer = this.querySelector('[data-match-offer]');
        if (offer && option?.dataset.offer) offer.textContent = option.dataset.offer;
      }, options);
      this.form.noValidate = true;
    }
    disconnectedCallback() {this.events?.abort();}
    async add() {
      if (this.checkBag || cartUncertain) {location.assign(this.dataset.cartUrl);return;}
      if (operation) return;
      const option = this.size.selectedOptions[0];
      if (!this.size.value || !option || option.disabled) {
        this.error.textContent = 'Choose a bra size to add this piece.';
        this.error.hidden = false;this.size.setAttribute('aria-invalid','true');this.size.focus();return;
      }
      operation = true;
      const buttons = [...document.querySelectorAll('[data-match-add], .cart__checkout-button')].map(button => ({button,disabled:button.disabled}));
      buttons.forEach(({button}) => {button.disabled = true;});
      this.form.setAttribute('aria-busy','true');this.button.textContent = 'Adding bra…';
      this.status.textContent = 'Adding the matching bra to your bag.';
      let posted = false, added = false;
      saveNotice('');
      try {
        let cart = await request(route('cart.js'));
        const matchingId = this.dataset.matchProduct;
        const hasBase = cart.items.some(item => String(item.product_id) === this.dataset.baseProduct);
        if (!hasBase) {this.status.textContent = 'Your bag has changed. Refresh it to view your matching pieces.';return;}
        if (cart.items.some(item => String(item.product_id) === matchingId)) {
          this.checkBag = true;this.status.textContent = 'This matching bra is already in your bag.';
          await refreshBag(cart, this.dataset.cartUrl);return;
        }
        posted = true;
        await request(route('cart/add.js'), {items:[{id:String(this.size.value),quantity:1}]});
        added = true;this.checkBag = true;window.CPShopping?.added(this.button,this.querySelector('img'));
        if (this.dataset.offerCode) {
          const code = this.dataset.offerCode;
          try {
            cart = await request(route('cart.js'));
            const codes = discountCodes(cart);
            if (!codes.some(c => c.toLowerCase() === code.toLowerCase())) codes.push(code);
            cart = await request(route('cart/update.js'), {discount:codes.join(',')});
            const applicable = cart.discount_codes?.some(item => item.code.toLowerCase() === code.toLowerCase() && item.applicable === true);
            if (!applicable) saveNotice('Your bra was added, but the matching offer did not apply to this bag. Check the total before checkout.');
          } catch (_) {
            saveNotice('Your bra was added. We could not confirm the matching discount; check your total before checkout.');
            cart = await request(route('cart.js'));
          }
        } else cart = await request(route('cart.js'));
        this.button.textContent = 'Bra added';this.status.textContent = 'Matching bra added. Your set is complete.';
        await refreshBag(cart, this.dataset.cartUrl);
      } catch (_) {
        // An error response can arrive after Shopify has changed the cart.
        if (posted) {cartUncertain = true;this.checkBag = true;}
        this.status.textContent = added ? 'Bra added, but the bag could not refresh. Open your bag to check it.' : posted ? 'We could not confirm the update. Check your bag before adding again.' : 'We could not check your bag. Please try again.';
      } finally {
        operation = false;this.form.removeAttribute('aria-busy');
        buttons.forEach(({button,disabled}) => {if (button.isConnected) button.disabled = disabled;});
        if (this.isConnected) {this.button.disabled = false;this.button.textContent = this.checkBag ? 'Check your bag' : 'Add bra to bag';}
      }
    }
  }
  customElements.define('cp-cart-matches', CartMatches);
  customElements.define('cp-cart-match', CartMatch);
})();
